// @flow

import React from 'react';
import { CheckBoxField } from '@src/formik-utils/FormFields';
import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '@src/configuration/estimate-commit-details';

export const EstimateCommitNetNewCustomerContainer = () => {
  const NET_NEW_CUSTOMER = 'net_new_customer';
  const { backendFieldName, displayName } =
    ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(NET_NEW_CUSTOMER);

  return (
    <CheckBoxField
      displayCheckBoxBelowLabel={true}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
    />
  );
};
